import { EmptyPoolExclChargeTypePolicy } from "constants/charge/EmptyPoolExclChargeTypePolicy";

export const EmpPoolChargeTypeDroOpts = () => {


    const getChargeTypeModel = () => {
        let items = [EmptyPoolExclChargeTypePolicy.CHARGE_TYPE_EMP, EmptyPoolExclChargeTypePolicy.CHARGE_TYPE_FLP];

        return [
            ...(items?.map(value => ({
                dropdownLabel: value,
                tagLabel: value,
                value: value
              }))?? [])];
    }

    return {
        getChargeTypeModel        
    }
}